import find from 'lodash/find'
import get from 'lodash/get'

export default {
  install(Vue, options) {
    Object.defineProperty(Vue.prototype, '$account', {
      get() {
        return this.$store.getters['accounts/currentAccount']
      }
    })

    Object.defineProperty(Vue.prototype, '$tokens', {
      get() {
        const account = this.$store.getters['accounts/currentAccount']

        const tokens = get(account, ['tokens'], [])
        const getByType = (type) => {
          return get(
            find(tokens, (t) => t.type === type),
            ['token'],
            null
          )
        }

        return {
          npm: getByType('npm'),
          api: getByType('api')
        }
      }
    })
  }
}
